/**
 * The ten-exam floor, in a module of its own.
 *
 * programs.ts carries the full school index, and the dashboard card reaches that
 * through a dynamic import on purpose. FloorProgress needs the number and
 * nothing else, so the number lives here and programs.ts re-exports it.
 */

/**
 * A rate built on fewer than ten first-time exams is one or two people. It
 * cannot carry a ranking, and it cannot carry a reading either: 17 schools would
 * otherwise publish an indexed "0% passed, 75.7 points under the national rate"
 * off a single candidate's bad morning. The floor applies everywhere a rate is
 * INTERPRETED. It never applies to the published table, where the figures are
 * ASWB's own and stay exactly as printed.
 */
export const RANKABLE_MIN_EXAMS = 10;
